import React, {Component} from 'react';
import {NavLink} from 'react-router-dom';
import * as Utils from '../../../utils/utils'
import { history } from '../../../store/configureStore';
import MegaMenuBg from '../../../assets/images/mega-menu-bg.png';

const MegaMenu = ({visibility, menuSet, onClose}) => {

  //console.log("MENU_SET", menuSet);
  let subMenus = menuSet && Object.keys(menuSet).length > 0
    ? Object.keys(menuSet)
    : [];
  //console.log("SUB_MENUS", subMenus);
  return visibility
    ? (
      <div className="mega-menu">
        {/* <div className="main-nav-background" style={{backgroundImage: 'url('+MegaMenuBg+')'}}></div> */}
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="row">
                {subMenus.map((menu, mid) => {
                  return (
                    <div className="col-md-3 sub-nav" key={mid}>
                      <div className="nav-title">{subMenus.length == 1
                          ? 'ALL ' + menu
                          : menu}</div>
                      <ul>
                        {menuSet[menu].map((menuItem, miid) => {
                          return (
                            <li key={miid}>
                              <NavLink to={`/products?category=${encodeURIComponent(menuItem)}`} onClick={onClose}>
                                {Utils.toTitleCase(menuItem)}
                              </NavLink>
                            </li>
                          )
                        })}
                      </ul>
                      <div className="extra-link">
                        <NavLink to={`/products?department=${encodeURIComponent(menu)}`} onClick={onClose}>View all</NavLink>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
    : null;
}

export default MegaMenu;



// WEBPACK FOOTER //
// ./src/components/commons/header/MegaMenu.js